import React, { useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import AdobeLogo from './AdobeLogo'
import DemoMenu from './DemoMenu'
import ShowMenu from '@react/react-spectrum/Icon/ShowMenu'

export default function Nav () {
    const { showSideNav, dispatch, isMobile } = useContext(DemoContext)
    function toggleView () {
        dispatch({ type: 'toggle-side-nav', payload: { showSideNav: !showSideNav } })
    }

    if (isMobile) {
        return <React.Fragment>
            <div className={showSideNav ? "adobe-side-menu-view-icon-hide" : "adobe-side-menu-view-icon-show" } onClick={ e => toggleView(e) }>
                <ShowMenu size="S" />
            </div>
            <div className={showSideNav ? "adobe-side-menu-view-show" : "adobe-side-menu-view-hide"}>
                <AdobeLogo />
                <DemoMenu />
            </div>
        </React.Fragment>
    } else {
        return <div>
            <AdobeLogo />
            <DemoMenu />
            <div className='footer'>
                <div>Copyright © 2023 Adobe.</div>
                <div>All rights reserved.</div>
            </div>
        </div>
    }
}
